import { useCallback } from 'react';
import { HttpClient } from '../helpers/httpClient.js';

function useVerifyPhoneNumberByOTP() {
    const verifyPhoneNumberByOTP = useCallback(async (props) => {
        const { phone, code } = props;
        return HttpClient.verifyPhoneNumberByOTP({ phone, code });
    }, []);
    return verifyPhoneNumberByOTP;
}

export { useVerifyPhoneNumberByOTP };
//# sourceMappingURL=useVerifyPhoneNumberByOTP.js.map
